/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Payment Gateway type
 */
export type CreatePaymentRequestType = typeof CreatePaymentRequestType[keyof typeof CreatePaymentRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePaymentRequestType = {
  WORLDPAY: 'WORLDPAY',
  STRIPE: 'STRIPE',
} as const;
